

<template>
  <div class="navigation">
    <ul class="container-width">
      <li
        :class="currentPath == item.path ? 'active' : ''"
        v-for="(item, index) in data"
        :key="index"
        @click="handleArticle(item.path)"
        :style="{ width: !DWIDTH ? item.width : '' }"
      >
        <a :href="item.path">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>
    
<script>
export default {
  name: "NAVIGATION",
  props: {
    data: {
      type: Array,
      default: [],
    },
    currentPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      DWIDTH: true,
    };
  },
  methods: {
    handleArticle(e) {
      let href = this.$router.resolve({
        path: e,
      });
      window.open(href.href, "_self");
    },
  },
  mounted() {
    if (window.screen.width < 720) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {},
  destroyed() {},
};
</script>
    
<style scoped lang="scss">
.navigation {
  width: 100%;
  position: relative;
  left: 0px;
  bottom: 0px;
  background-color: rgba(0, 71, 157, 0.9);
  ul {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;

    li {
      padding: 0 20px;
      box-sizing: border-box;
      text-align: center;
      height: 60px;
      line-height: 60px;
      margin-right: 20px;
      cursor: pointer;
      a {
        color: #fff;
        font-size: 1.2rem;
      }
    }
    li:hover {
      background-color: #842331;
    }
  }
  .active {
    background-color: #842331;
  }
}
@media only screen and (max-width: 1280px) {
}
/* 小屏幕（平板，大于等于 420px） */
@media only screen and (max-width: 1080px) {
  .navigation {
    ul {
      flex-wrap: wrap;
      width: 100%;
      li {
        padding: 0px;
        height: 36px;
        line-height: 36px;
        margin-right: 0px;
        width: 33.3333%;
        a {
          font-size: 12px;
        }
      }
    }
  }
}

/* 小屏幕（平板，大于等于 420px） */

@media only screen and (max-width: 421px) {
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 768px) {
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
  .navigation {
    position: absolute;
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 1330px) {
}
</style>
    
  
     